import axios, { AxiosError, AxiosResponse } from "axios";
import { useRouter } from "vue-router";

export default function useErpApiClient() {
  const router = useRouter();

  type axiosRequestCb = () => Promise<AxiosResponse>;
  const request = (f: axiosRequestCb) => {
    return f().catch((e: AxiosError) => {
      if (401 === e.response?.status) {
        router.push({ name: "login" });

        throw new Error(
          "Error lanzado dentro del flujo normal del programa, para redirigir a página de Login.",
        );
      }
      throw new Error(
        "Ocurrió un error inesperado realizando request: " + f.toString(),
      );
    });
  };

  const checkSession = () => {
    // Trampilla para comprobar estado de la sesión (existencia de la cookie de sesión creada en Go), sin crear una nueva ruta en el backend.
    return axios
      .get("/api/vetlla/index")
      .then(() => true)
      .catch(() => false);
  };

  return {
    request,
    checkSession,
  };
}
